export default "__VITE_ASSET__B1$bncRY__"